import CAJA1110ResponseModel from '@/api/data/CAJ/CAJG1110/CAJA1110ResponseModel'
import CAJA1110RequestModel from '@/api/data/CAJ/CAJG1110/CAJA1110RequestModel'
import ApiUrlConstants from '../../../common/ApiUrlConstants'
import RestService from '../../../common/RestService'

export default class CAJG1110Service {
  /**
   *
   * @returns string base 64
   */
  public async callAPICAJA1110(): Promise<CAJA1110ResponseModel> {
    const caja1110RequestModel = new CAJA1110RequestModel()
    const caja1110ResponseModel: CAJA1110ResponseModel = <
      CAJA1110ResponseModel
    > await RestService.post(ApiUrlConstants.CAJA1110, caja1110RequestModel)
    return caja1110ResponseModel
  }
}
